import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PhaseType } from "../../../types/ScientificModule";

const initialState: PhaseType = {
    id: "",
    description: "",
    start: false,
    end: false,
    idPhaseNext: undefined,
    idPhasePrevious: undefined,
    idProjectType: "",
    status: false,
};

const phasesSlice = createSlice({
    name: "phases",
    initialState,
    reducers: {
        setPhasesData: (state, action: PayloadAction<PhaseType>) => ({
            ...state,
            ...action.payload,
        }),
        resetPhasesData: () => ({ ...initialState }),
    },
});

export const { setPhasesData, resetPhasesData } = phasesSlice.actions;

export default phasesSlice.reducer;
